import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function DynamicFeildAttachWorkflow(props) {
  const { entity } = props;
  return (
    <div
      className={`dynamicfieldlist-add-workflow ${
        entity.wfId ? "workflow-attached" : ""
      }`}
      data-test="attachworkflowbtn-add-workflow-button"
      onClick={() => props.toggleWorkFlowScreen({ flag: true, entity })}
      onKeyPress={() => null}
      role="button"
      tabIndex="0">
      {entity.wfId ? (
        <FontAwesomeIcon
          icon={["far", "network-wired"]}
          className="dynamicfieldlist-icon-network"
        />
      ) : (
        <FontAwesomeIcon
          icon={["far", "network-wired"]}
          className="dynamicfieldlist-icon-plus"
        />
      )}
      {entity.wfId ? "Workflow attached" : "Attach workflow"}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFeildAttachWorkflow/DynamicFeildAttachWorkflow.js